import { type ArticleDataType } from '../providers/ArticlesTableProvider/utils/ArticleTypes';

export const calculateArticlesLength = (articles: Array<ArticleDataType>) => {
  return articles.filter(Boolean).reduce((acc, article) => {
    return acc + parseInt(article?.mouldLength ?? 0, 10);
  }, 0);
};
